import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#invite-clients')) {
      $(document).on('submit', '#invite-clients-form', function () {
        const $form = $(this);

        // validate form
        $form.find('label.form-error').hide();
        if (!$form.find('#emails').val().length) {
          $('label[for=emails].form-error').show();
        }
        if (!$form.find('#subject').val().length) {
          $('label[for=subject].form-error').show();
        }

        const emails = $form.find('#emails').val();
        if (!emails.includes('@') || emails.includes(',')) {
          $('label[for=emails].form-error').show();
        }

        const selectized = $form.find('.field--invite-clients--selectized')[0];
        if (
          selectized &&
          selectized.selectize &&
          selectized.selectize.$control_input.val().trim().length
        ) {
          $('label[for=emails].form-error').show();
        }

        if ($form.find('.form-error:visible').length) {
          $form.find('.form-error:visible:first').focus();
          return false;
        }

        // retrieve message from iFrame and store it in hidden field
        const messageVal = $($('.invite-clients__iframe')[0].contentDocument)
          .find('textarea[name=message]')
          .val();
        const headlineVal = $($('.invite-clients__iframe')[0].contentDocument)
          .find('textarea[name=headline]')
          .val();
        const testimonialVal = $($('.invite-clients__iframe')[0].contentDocument)
          .find('textarea[name=testimonial]')
          .val();
        $form.find('#message').val(messageVal);
        $form.find('#headline').val(headlineVal);
        $form.find('#testimonial').val(testimonialVal);
      });

      $('.change-email-image__file-input').fileupload({
        url: '/user_files',
        done: (_, data) => {
          // show or hide reset image link
          $('.change-email-image__reset').html(data.result);

          // change iframe image
          $($('.invite-clients__iframe')[0].contentDocument)
            .find('.invite_client_background_image')
            .attr('src', $(data.result).data('background-image-url'));
        },
        fail: (_, data) => {
          alert(data.jqXHR.responseJSON.error);
        },
      });
      $('.invite-clients__iframe').on('load', (e) => {
        $(e.target)
          .contents()
          .on('change', 'textarea', (e) => {
            $('.invite-clients-email-controls__restore-default-link--hidden').removeClass(
              'invite-clients-email-controls__restore-default-link--hidden'
            );
          });
      });
      $(document).on('change', '.radio--invite-clients-paid', (e) => {
        if ($('.invite-clients-form__questionnaires-selection').length > 0) {
          $('.invite-clients-form__questionnaires-selection').toggleClass(
            'hide',
            $(e.target).val() === 'true'
          );
          const linkText = $(e.target).val() === 'true' ? 'Design Packages' : 'Request a Project';
          $($('.invite-clients__iframe')[0].contentDocument)
            .find('.invite_client_link')
            .text(linkText);
        }
      });

      const bulkImportForm = '.js-bulk-import-emails';

      $(document).on('change', `${bulkImportForm} .uploader__hidden-fileinput`, (e) => {
        if ($(e.target).val()) {
          $(`${bulkImportForm} .uploader__file`).html(
            `<div class="uploader__check-icon"></div>${e.target.files[0].name}`
          );
        }
      });

      $(document).on('dragover dragenter', `${bulkImportForm} .uploader`, (e) => {
        e.preventDefault();
        e.stopPropagation();
        $(e.currentTarget).addClass('uploader--hover');
      });

      $(document).on('dragleave dragend drop', `${bulkImportForm} .uploader`, (e) => {
        e.preventDefault();
        e.stopPropagation();
        $(e.currentTarget).removeClass('uploader--hover');
      });

      $(document).on('drop', `${bulkImportForm} .uploader`, (e) => {
        const file = e.originalEvent.dataTransfer.files[0];
        if (!file) {
          return;
        }

        const input = $(`${bulkImportForm} .uploader__hidden-fileinput`)[0];
        const csvMimeTypes = ['text/csv', 'application/csv', 'application/vnd.ms-excel'];
        const isCsvFile =
          csvMimeTypes.includes(file.type) || file.name.toLowerCase().endsWith('.csv');
        if (!isCsvFile) {
          input.value = '';
          $(`${bulkImportForm} .uploader__file`).text('Please drop a valid CSV file.');
          return;
        }

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        input.files = dataTransfer.files;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      $(document).on('submit', bulkImportForm, () => {
        const file = $(`${bulkImportForm} .uploader__hidden-fileinput`)[0].files[0];
        const filereader = new FileReader();
        filereader.onload = (e) => {
          const emails = e.target.result;
          if (emails.length) {
            $('#invite-clients').find('#bulk_import').val(true);
          }

          emails.split(/\r?\n|\r|,/g).forEach((email) => {
            email = email.trim();
            if (email.length > 0) {
              $('.field--invite-clients--selectized')[0].selectize.createItem(email);
            }
          });
        };

        filereader.readAsText(file);
      });
    }

    if ($('.field--invite-clients--selectized').selectize !== undefined) {
      $('.field--invite-clients--selectized').selectize({
        plugins: ['remove_button'],
        delimiter: ',',
        persist: false,
        copyClassesToDropdown: false,
        createOnBlur: true,
        onBlur() {
          const $input = this.$input;
          // Find the clear button within the selectize control
          const $clearButton = $input
            .siblings('.selectize-control')
            .find('.selectize-control--clear-search');

          // Trigger the clear button to reset the search text and hide the (x) button
          $clearButton.click();
        },
        render: {
          item: (data, escape) => {
            return `<div class="invite-clients__field-tag-item">${escape(data.text)}</div>`;
          },
        },
        create: (input) => {
          const REGEX_EMAIL =
            "^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@" +
            '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$';
          if (new RegExp(REGEX_EMAIL, 'i').test(input)) {
            return {
              value: input,
              text: input,
            };
          }

          return false;
        },
        onInitialize() {
          this.$wrapper.removeClass('field');
        },
      });
    }

    $(document).on('ajax:success', '.change-email-image__reset-link', function () {
      $($('.invite-clients__iframe')[0].contentDocument)
        .find('.invite_client_background_image')
        .attr('src', $(this).data('reset-image-url'));
      $('.change-email-image__reset').html('');
    });

    $(document).on('ajax:success', '.invite-clients-email-controls__restore-default-link', (e) => {
      $('.invite-clients__iframe')[0].src = $('.invite-clients__iframe')[0].src;
      $(e.target).addClass('invite-clients-email-controls__restore-default-link--hidden');
    });
  });
});
